import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={200}
    height={200}
    className="icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M512 1023.42a32.749 32.749 0 0 1-12.28 0A781.877 781.877 0 0 1 47.376 424.73L21.792 258.428a29.679 29.679 0 0 1 16.886-31.726L499.208 3.09a30.19 30.19 0 0 1 26.608 0l460.53 223.612a29.679 29.679 0 0 1 16.886 31.726L977.647 424.73a781.877 781.877 0 0 1-453.366 598.69 32.749 32.749 0 0 1-12.281 0zM84.73 271.22l22.515 144.3A721.497 721.497 0 0 0 512 959.968 721.497 721.497 0 0 0 916.755 415.52l22.514-144.3L512 63.982z"
    />
    <path
      fill="currentColor"
      d="M494.602 688.256a29.679 29.679 0 0 1-21.491-8.7L323.694 530.142a30.702 30.702 0 0 1 0-42.983 30.19 30.19 0 0 1 42.472 0l128.436 126.901L722.31 386.353a30.19 30.19 0 0 1 42.47 0 30.702 30.702 0 0 1 0 42.983L516.095 678.022a29.679 29.679 0 0 1-21.492 10.234z"
    />
  </svg>
);
export default SvgComponent;
